import {
  PAYOFF_CALLABILITY_BARRIER_LEVEL,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_CALLABILITY_FREQUENCY,
  PAYOFF_CALLABILITY_OBS_FREQUENCY,
  PAYOFF_CALLABILITY_TOUCH_BREAK,
  PAYOFF_COUPON_BARRIER_LEVEL,
  PAYOFF_COUPON_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_BARRIER_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_DAY_COUNT,
  PAYOFF_COUPON_FIXED_PERIODS,
  PAYOFF_COUPON_FIXED_RATE,
  PAYOFF_COUPON_FLOATING_PERIODS,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_MEMORY,
  PAYOFF_COUPON_MULTIPLIER,
  PAYOFF_COUPON_OBVS_FREQUENCY,
  PAYOFF_COUPON_PERFORMANCE_CALCULATION,
  PAYOFF_COUPON_RESTRIKE,
  PAYOFF_COUPON_RATE_INTERPOLATION,
  PAYOFF_COUPON_RATE_RESET,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_SCHEDULE,
  PAYOFF_COUPON_TOUCH_BREAK,
  PAYOFF_COUPON_TYPE,
  PAYOFF_COUPON_STRIKE,
  PAYOFF_COUPON_DIGITAL_STRIKE,
  PAYOFF_COUPON_DIGITAL_AMOUNT,
  PAYOFF_COUPON_SPREAD,
  PAYOFF_COUPON_CAP,
  PAYOFF_COUPON_FLOOR,
  PAYOFF_CALLABILITY_BARRIER_TYPE,
  PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_CONDITIONAL_RATE,
  PAYOFF_COUPON_CONDITIONAL_STRIKE,
  PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
  PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
  PAYOFF_COUPON_BARRIER_BREAK,
  PAYOFF_COUPON_COUPON_CALCULATION_DAYS,
  PAYOFF_COUPON_RANGE_ACCRUAL_RATE,
  PAYOFF_COUPON_SUSPENSION_LENGTH,
  PAYOFF_COUPON_FIXED_RATE_TYPE,
  PAYOFF_COUPON_FIXED_RATE_STEP,
} from './product-capture-field-selectors.consts';

import { DAY_COUNT_KEYS } from 'src/app/product-capture/model/consts/day-count.const';
import { FCFieldEffect, FCSelector } from '../../model/form-config.interface';
import { PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP } from './product-capture-group-selectors.consts';
import { BARRIER_AMOUNT_WITH_CUSTOM } from 'src/app/product-capture/model/consts/barrier-amout.const';
import { RANGE_ACCRUAL_DEFAULTS } from '../../model/product-settings/range_accrual.settings';

const DAY_COUNT_ONE_ONE_SETTER_EFFECT = {
  formControlNames: [PAYOFF_COUPON_DAY_COUNT],
  selectValues: [DAY_COUNT_KEYS.ONE_ONE],
};

const DAY_COUNT_EMPTY_SETTER_EFFECT = {
  formControlNames: [PAYOFF_COUPON_DAY_COUNT],
  selectValues: [''],
};

const CLEAR_MEMORY_EFFECT = {
  formControlNames: [PAYOFF_COUPON_MEMORY],
  selectValues: [null],
};

const CLEAR_BARRIER_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
  selectValues: [null],
};

const CLEAR_FIXED_RATE_TYPE_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_COUPON_FIXED_RATE_TYPE],
  selectValues: ['FLAT'],
};

const BARRIER_TYPE_FLAT_SETTER_EFFECT = {
  formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
  selectValues: ['FLAT'],
  hidden: false,
};

const CLEAR_FIXED_PERIODS_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_COUPON_FIXED_PERIODS],
  selectValues: [null],
};

const CLEAR_FLOATING_PERIODS_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_COUPON_FLOATING_PERIODS],
  selectValues: [null],
};

const CLEAR_RATE_RESET_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_COUPON_RATE_RESET],
  selectValues: [null],
};

const CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT: FCFieldEffect = {
  formControlNames: [
    PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
    PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
    PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
    PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
    PAYOFF_COUPON_BARRIER_BREAK,
    PAYOFF_COUPON_COUPON_CALCULATION_DAYS,
    PAYOFF_COUPON_RANGE_ACCRUAL_RATE,
    PAYOFF_COUPON_SUSPENSION_LENGTH,
  ],
  hidden: true,
  selectValues: [null],
};

const BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS: FCFieldEffect[] = [
  {
    formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_BARRIER_LEVEL],
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_BARRIER_STEP_SIZE],
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_OBVS_FREQUENCY],
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_TOUCH_BREAK],
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_FREQUENCY],
    readOnly: false,
  },
];

const RANGE_ACCRUAL_BARRIER_FIELDS = [
  {
    formControlNames: [
      PAYOFF_COUPON_BARRIER_LEVEL,
      PAYOFF_COUPON_BARRIER_STEP_SIZE,
    ],
    selectValues: [null],
    hidden: true,
    readOnly: true,
  },
  {
    formControlNames: [
      PAYOFF_COUPON_FREQUENCY,
      PAYOFF_COUPON_TOUCH_BREAK,
      PAYOFF_COUPON_OBVS_FREQUENCY,
      PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
      PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
    ],
    hidden: false,
    readOnly: false,
  },
];

const RESTRIKE_FALSE_SETTER_EFFECT = {
  formControlNames: [PAYOFF_COUPON_RESTRIKE],
  selectValues: [false],
};

export const COUPON_TYPE: FCSelector = {
  formControlNames: [PAYOFF_COUPON_TYPE],
  options: [
    {
      id: 'NONE',
      label: 'None',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_CONVERSION,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
            PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
            PAYOFF_COUPON_BARRIER_BREAK,
            PAYOFF_COUPON_COUPON_CALCULATION_DAYS,
            PAYOFF_COUPON_RANGE_ACCRUAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
          ],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FIXED',
      label: 'Fixed',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE
          ],
          hidden: false,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_CONVERSION,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_ONE_ONE_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FLOATING',
      label: 'Floating',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_RATE_INTERPOLATION],
          selectValues: ['NONE'],
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FIXED_TO_FLOATING',
      label: 'Fixed-to-floating',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_RATE_INTERPOLATION],
          selectValues: ['NONE'],
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FLOATING_TO_FIXED',
      label: 'Floating-to-fixed',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_RATE_INTERPOLATION],
          selectValues: ['NONE'],
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'SNOWBALL',
      label: 'Snowball',
      effects: [
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_SCHEDULE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_MEMORY],
          selectValues: [true],
          readOnly: true,
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          selectValues: ['AUTOCALL'],
          readOnly: true,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
      concatFieldRules: [
        {
          formControlNames: [PAYOFF_CALLABILITY_OBS_FREQUENCY],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_OBVS_FREQUENCY],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_OBS_FREQUENCY,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_BARRIER_TYPE],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_BARRIER_TYPE,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_BARRIER_LEVEL],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_BARRIER_LEVEL],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_BARRIER_LEVEL,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_BARRIER_STEP_SIZE],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_BARRIER_STEP_SIZE],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_FREQUENCY],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_FREQUENCY],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_FREQUENCY,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_TOUCH_BREAK],
          options: [
            {
              id: '',
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [PAYOFF_COUPON_TOUCH_BREAK],
                  copyFieldValueFrom: PAYOFF_CALLABILITY_TOUCH_BREAK,
                  readOnly: true,
                  hidden: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'CONDITIONAL',
      label: 'Conditional',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_DAY_COUNT,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
          hidden: false,
          options: [...BARRIER_AMOUNT_WITH_CUSTOM],
        },
        {
          formControlNames: [PAYOFF_COUPON_MEMORY],
          readOnly: false,
        },
        {
          ...DAY_COUNT_ONE_ONE_SETTER_EFFECT,
        },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
      ],
    },
    {
      id: 'FIXED_TO_FORWARD',
      label: 'Fixed-to-Forward',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_FLOATING_PERIODS,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_FLOATING_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FORWARD',
      label: 'Forward',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'CALL',
      label: 'Call',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_FLOOR,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FIXED_TO_CALL',
      label: 'Fixed-to-Call',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_FLOOR,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'DIGITAL',
      label: 'Digital',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_FLOOR,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_DIGITAL_STRIKE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'FIXED_TO_DIGITAL',
      label: 'Fixed-to-Digital',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_FLOOR,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
    {
      id: 'LOWEST_FX_PERFORMANCE',
      label: 'Lowest FX Performance',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_TYPE,
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_FLOOR,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_SCHEDULE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_MULTIPLIER],
          selectValues: [
            {
              minValue: null,
              maxValue: null,
              value: '1%',
              indicativeValue: null,
            },
          ],
          hidden: false,
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_PERFORMANCE_CALCULATION],
          selectValues: ['CURRENT_FIXING_MINUS_COUPON_STRIKE'],
          hidden: false,
          readOnly: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          ...RESTRIKE_FALSE_SETTER_EFFECT,
          hidden: false,
          readOnly: true,
        },
        {
          ...CLEAR_FIXED_PERIODS_EFFECT,
        },
        {
          ...CLEAR_RATE_RESET_EFFECT,
        },
        {
          ...CLEAR_BARRIER_EFFECT,
        },
        { 
          ...CLEAR_FIXED_RATE_TYPE_EFFECT 
        },
        {
          ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT,
        },
      ],
    },
    {
      id: 'RANGE_ACCRUAL',
      label: 'Range Accrual',
      effects: [
        ...RANGE_ACCRUAL_DEFAULTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
          ],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_COUPON_OBVS_FREQUENCY],
          hidden: false,
          selectValues: ['DAILY_AT_CLOSE'],
        },
        { ...BARRIER_TYPE_FLAT_SETTER_EFFECT },
        {
          ...RESTRIKE_FALSE_SETTER_EFFECT,
          hidden: true,
          readOnly: true,
        },
        { ...DAY_COUNT_ONE_ONE_SETTER_EFFECT, hidden: false, readOnly: false },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        ...RANGE_ACCRUAL_BARRIER_FIELDS,
      ],
    },
    {
      id: 'FIXED_TO_RANGE_ACCRUAL',
      label: 'Fixed-to-Range Accrual',
      effects: [
        ...RANGE_ACCRUAL_DEFAULTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_COUPON_OBVS_FREQUENCY],
          hidden: false,
          selectValues: ['DAILY_AT_CLOSE'],
        },
        { ...BARRIER_TYPE_FLAT_SETTER_EFFECT },
        { ...RESTRIKE_FALSE_SETTER_EFFECT },
        { ...DAY_COUNT_ONE_ONE_SETTER_EFFECT, hidden: false, readOnly: false },
        { ...CLEAR_FIXED_PERIODS_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        ...RANGE_ACCRUAL_BARRIER_FIELDS,
      ],
    },
    {
      id: 'FIXED_AND_CONDITIONAL',
      label: 'Fixed-and-Conditional',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          ...CLEAR_FIXED_PERIODS_EFFECT,
        },
        {
          ...CLEAR_RATE_RESET_EFFECT,
        },
        {
          ...CLEAR_BARRIER_EFFECT,
        },
        { 
          ...CLEAR_FIXED_RATE_TYPE_EFFECT 
        },
        {
          formControlNames: [
            PAYOFF_COUPON_TYPE,
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_CONDITIONAL_RATE,
            PAYOFF_COUPON_CONDITIONAL_STRIKE,
            PAYOFF_COUPON_SCHEDULE,
          ],
          hidden: false,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_PERFORMANCE_CALCULATION,
            PAYOFF_COUPON_RESTRIKE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_SPREAD,
            PAYOFF_COUPON_FLOOR,
            PAYOFF_COUPON_CAP,
            PAYOFF_COUPON_DIGITAL_STRIKE,
            PAYOFF_COUPON_DIGITAL_AMOUNT,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_RATE_INTERPOLATION,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_STRIKE,
            PAYOFF_COUPON_FIXED_RATE_TYPE,
            PAYOFF_COUPON_FIXED_RATE_STEP
          ],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_COUPON_FREQUENCY],
          selectValues: ['AT_MATURITY'],
          readOnly: true,
        },
        {
          ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT,
        },
      ],
    },
    {
      id: '',
      effects: [
        ...BARRIER_FIELDS_NOT_READ_ONLY_EFFECTS,
        {
          formControlNames: [
            PAYOFF_COUPON_FREQUENCY,
            PAYOFF_COUPON_CONVERSION,
            PAYOFF_COUPON_SCHEDULE,
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_PERIODS,
            PAYOFF_COUPON_REFERENCE_RATE,
            PAYOFF_COUPON_SPREAD_CAP_FLOOR_GROUP, // Virtual field group
            PAYOFF_COUPON_DAY_COUNT,
            PAYOFF_COUPON_BARRIER_LEVEL,
            PAYOFF_COUPON_OBVS_FREQUENCY,
            PAYOFF_COUPON_MEMORY,
            PAYOFF_COUPON_TOUCH_BREAK,
            PAYOFF_COUPON_MULTIPLIER,
            PAYOFF_COUPON_RATE_RESET,
            PAYOFF_COUPON_BARRIER_TYPE,
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
          selectValues: [''],
          readOnly: false,
        },
        {
          ...DAY_COUNT_EMPTY_SETTER_EFFECT,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_RATE_RESET_EFFECT },
        { ...CLEAR_MEMORY_EFFECT },
        { ...CLEAR_RANGE_ACCRUAL_FIELDS_EFFECT },
        { ...CLEAR_FIXED_RATE_TYPE_EFFECT },
      ],
    },
  ],
};
